export const VendorsResource = {
  name: "Vendors",
  path: "/purchases/vendors",
  access: ["read-vendors"],
};
